import { render } from "./stronaPolityka.vue?vue&type=template&id=3929a851&scoped=true"
const script = {}

import "./stronaPolityka.vue?vue&type=style&index=0&id=3929a851&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3929a851"]])

export default __exports__